import React, { Component } from 'react';
import axios from 'axios';
import ambiente from '../../config/ambienteConfig';

class SaldoContas extends Component {
    constructor(props) {
        super(props);
        this.state = {
            saldo: []
        };
    }

    componentDidMount = async () => {
        try { 
            const res = await axios.get(`${ambiente.dev.server}/saldo`);
            this.setState({ saldo : res.data });
        } catch (err) {
            console.log(err);
        }
    }
    
    render() {
        let acumulado = 0.0;
        return (
            <table className="table table-hover table-bordered">
                <thead className="thead-inverse">
                    <tr>
                        <th>Conta</th>
                        <th>Saldo</th>
                    </tr>
                </thead>
                <tbody>
                    { this.state.saldo.map(item => {
                        acumulado += parseFloat(item.saldo);
                        return (
                            <tr key={item.conta_id}>
                                <td>{item.conta}</td>
                                <td>{parseFloat(item.saldo).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</td>
                            </tr>);
                    })}
                    <tr>
                        <td><b>Total</b></td>
                        <td>{acumulado.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</td>
                    </tr>
                </tbody>
            </table>
        );
    }
}

export default SaldoContas;



// WEBPACK FOOTER //
// ./src/components/home/SaldoContas.js